<template>
  <Loading :loading="loading">
    <div class="c-romdvc"></div>
  </Loading>
</template>
<script>
import Loading from '@/components/data-loading'
import { mapState, mapMutations } from 'vuex'
import wxlogin from '@/mixin/wxlogin'
import { isWeChatBrowser } from '@/config/h5/index.js'
export default {
  components: { Loading },
  mixins: [wxlogin],
  data() {
    return {
      openId: ''
    }
  },
  computed: {
    ...mapState('loading', ['loading'])
  },
  created() {
    this.setLoading(true)
    if (isWeChatBrowser) {
      this.getWXCode()
    }
  },
  methods: {
    ...mapMutations('loading', ['setLoading'])
  }
}
</script>

<style scoped lang="less">
.c-romdvc {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
</style>
